import {JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {NBS} from "./nbs";
import {IndicadorOperacaoIBSCBS} from "./indicador.operacao.ibs.cbs";
import {
  VinculoNBSIndicadorOperacaoClassificacaoTributaria
} from "./vinculo.nbs.indicador.operacao.classificacao.tributaria";

@JacksonType("VinculoNBSIndicadorOperacao")
@JsonIdentityInfo()
export class VinculoNBSIndicadorOperacao extends SonnerBaseEntity {

  id: number;

  @JacksonType("NBS")
  nbs: NBS;

  @JacksonType("IndicadorOperacaoIBSCBS")
  indicador: IndicadorOperacaoIBSCBS

  @JacksonType("VinculoNBSIndicadorOperacaoClassificacaoTributaria")
  classificacoes: VinculoNBSIndicadorOperacaoClassificacaoTributaria[];

}
